import type { CreateClientConfig } from 'gen/api/client.gen';
import axiosInterceptor from './axiosClient';

/**
 * Runtime configuration for the generated hey-api axios client.
 *
 * `@hey-api/openapi-ts` calls this on client initialization (wired up via
 * `runtimeConfigPath` in `openapi-ts.config.ts`). We hand it our existing
 * pre-configured axios instance so the generated SDK inherits the auth
 * request interceptor (bearer token, admin-mode header, token refresh) and the
 * `baseURL` set up in `axiosClient.ts` — no auth logic is duplicated here.
 */
export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  axios: axiosInterceptor,
  baseURL: import.meta.env.VITE_API_BASE_URL as string,
});
